module.exports = __webpack_public_path__ + "img/valance-wave-scallop.007cea4d.svg";